import React from "react";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { TextField } from "@mui/material";

const darkTheme = createTheme({
  palette: {
    mode: "dark", 
    primary: {
      main: "#ffffff",
    },
    text: {
      primary: "#ffffff",
      secondary: "#ffffff",
    },
    background: {
      default: "transparent",
      paper: "#333333",
    },
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiInputBase-input": {
            color: "#ffffff",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#ffffff",
          },
          "& .MuiOutlinedInput-root": {
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#ffffff",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#ffffff",
            },
          },
          "& .MuiInputLabel-root": {
            color: "#ffffff",
          },
          "& .MuiInputLabel-root.Mui-focused": {
            color: "#ffffff",
          },
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          color: "#ffffff",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: "#333333",
          color: "#ffffff",
        },
      },
    },
    MuiPickersDay: {
      styleOverrides: {
        root: {
          color: "#ffffff",
          "&:hover": {
            backgroundColor: "#555555",
          },
          "&.Mui-selected": {
            backgroundColor: "#777777",
            color: "#ffffff",
          },
        },
      },
    },
    MuiPickersCalendarHeader: {
      styleOverrides: {
        switchHeader: {
          color: "#ffffff",
        },
      },
    },
    MuiPickersYear: {
      styleOverrides: {
        yearButton: {
          color: "#ffffff",
        },
      },
    },
    MuiPickersMonth: {
      styleOverrides: {
        monthButton: {
          color: "#ffffff",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          color: "#ffffff",
        },
      },
    },
  },
});

const DatePickers = ({ date, setDate, dueDate, setDueDate }) => {
  return (
    <>
      <div className="col-lg-2 col-md-2">
        <ThemeProvider theme={darkTheme}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <MobileDatePicker
              label="Invoice Date"
              inputFormat="MM/DD/YYYY"
              value={date}
              onChange={(newValue) => setDate(newValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  sx={{
                    input: { color: '#ffffff' },
                    svg: { color: '#ffffff' },
                  }}
                />
              )}
            />
          </LocalizationProvider>
        </ThemeProvider>
      </div>
      <div className="col-lg-2 col-md-2">
        <ThemeProvider theme={darkTheme}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <MobileDatePicker
              label="Due Date"
              inputFormat="MM/DD/YYYY"
              value={dueDate}
              onChange={(newValue) => setDueDate(newValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  sx={{
                    input: { color: '#ffffff' },
                    svg: { color: '#ffffff' },
                  }}
                />
              )}
            />
          </LocalizationProvider>
        </ThemeProvider>
      </div>
    </>
  );
};

export default DatePickers;